<!-- 城管 -->
<template>
    <MainLayout
        style="height: calc(100% - 16px); padding: 0px 8px"
        leftWidth="320px"
        rightWidth="320px"
        @toggleRight="handleToggleRight"
    >
        <News slot="header"> </News>
        <!-- 左侧 -->
        <LeftAside
            slot="left"
            :searchForm="searchForm"
            :tabControlList="tabControlList"
            :onEventData="onEventData"
            :onPictureData="onPictureData"
            @dingweiClick = "dingweiClick"
            @checkHeHuIslandProjectList="checkHeHuIslandProjectList"
            @eventListClick="handleEventListClick"
        />
        <!-- 中间地图 -->
        <div ref="middlRef" slot="main" class="c-middle" style="padding: 12px">
            <MapContainer
                ref="mapRef"
                :useServiceConfigZoom="false"
                :zoom="12"
                :bottomToolConfig="bottomToolConfig"
            >
                <template slot="openlayer">
                      <!-- 湖岛项目，照片图层 -->
                      <OpenlayerHeZhangLayer :hzList="heHuIslandProjectList" :positionFitVal="positionFitVal" :photoList="photoList"></OpenlayerHeZhangLayer>
                    <!-- 事件点 -->
                    <EventPoints v-if="eventList && eventList.length > 0" :eventList="eventList"></EventPoints>
                    <!-- 全景点位 -->
                    <PanoramaPoint layerVisible :pointList="panoramalocationList"></PanoramaPoint>
                </template>
            </MapContainer>
            <!-- 头部类型选择 -->
            <mapTopTab
                :tabList="tabList"
                :tabControlList="tabControlList"
                :currentTab="searchForm.currentTab"
                @changeDataControl="changeDataControl"
                @changeTypeControl="changeTypeControl"
            ></mapTopTab>

            <!-- 底部时间轴 -->
            <SelectYear
                style="bottom: 80px"
                :selectTime="selectTime"
                :openScroll="false"
                @changeSelectTime="changeSelectTime"
            ></SelectYear>
        </div>
        <!-- 右侧 -->
        <RightAside ref="rightRef" slot="right" :queryDate="searchForm.queryDate" />
    </MainLayout>
</template>

<script>
import { LTile, LWMSTile } from '@OpenLayersCommon';
import { WKT } from 'ol/format';
import MainLayout from '@/components/layout';
import News from '@/page/mainPage/components/news/News.vue';
import mapTopTab from '@/page/business/components/mapTopTab/index.vue';
import SelectYear from '@/page/business/components/SelectYear/SelectYear.vue';
import RightAside from './components/RightAside.vue';
import LeftAside from './components/LeftAside.vue';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import EventPoints from '@/page/mainPage/mapComponents/EventPoints.vue';
import OpenlayerHeZhangLayer from '../components/OpenlayerHeZhangLayer.vue';
import PanoramaPoint from '@/page/mainPage/mapComponents/panorama-point.vue';
import { hzControl } from '@/page/business/components/mapTabs.js';
import MapPhoto from '@/page/business/components/mapPhoto/index.vue';
import apiPanorama from '@/api/dataManagement/panorama';

const WktInstance = new WKT();
export default {
    components: {
        MainLayout,
        News,
        LeftAside,
        RightAside,
        MapContainer,
        EventPoints,
        SelectYear,
        mapTopTab,
        OpenlayerHeZhangLayer,
        MapPhoto,
        PanoramaPoint,
    },
    props: {},

    data() {
        // 计算当前日期的前一个月
        const getPrevMonth = () => {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1; // 当前月份（1-12）

            // 计算前一个月的年和月
            let prevYear;
            let prevMonth;
            if (currentMonth === 1) {
                // 若当前是1月，前一个月是去年12月
                prevYear = currentYear - 1;
                prevMonth = 12;
            } else {
                prevYear = currentYear;
                prevMonth = currentMonth - 1;
            }

            // 转换为selectLeftActiveMonth格式：(年份-2021)*12 + 月份

            return prevMonth;
        };
        return {

            currentLeftTab: { index: 0 },
            positionFitVal: [],
            eventList: [],
            photoList: [],
            panoramalocationList: [], // 全景点列表

            heHuIslandProjectList: [],

            // 默认选中时间对象
            // 默认选中时间对象
            selectTime: {
                year: new Date().getFullYear(),
                yearLeft: new Date().getFullYear(),
                yearRight: new Date().getFullYear(),
                monthLeft: getPrevMonth(), // 默认今年1月
                monthRight: new Date().getMonth() + 1,
                dayLeft: new Date().getDate(),
                dayRight: new Date().getDate(),
            },
            searchForm: {
                queryDate: [],
                currentTab: 'riverLakeIslandAndProject',
                eventTypeId: '',
                eventStatus: '',
            },
            tabControlList: ['riverLakeIslandAndProject', 'events', 'photos'],
            tabList: hzControl,
        };
    },
    computed: {
        /**
         * 底部工具栏的配置
         *
         * @returns 返回底部工具栏的配置对象
         */
        bottomToolConfig() {
            return {
                showFly: false,
                showSplit: false, // 只有在左侧选中影像列表时才显示比对按钮
            };
        },
    },
    methods: {
        onEventData(data) {
            this.eventList = data;
            // console.log('onEventData', data);
        },
        onPictureData(data) {
            this.photoList = data;
            // console.log('onPictureData', data);
        },

        changeDataControl(dataList) {
            // console.log('changeDataControl', dataList);
            this.tabControlList = dataList;
        },
        changeTypeControl(type) {
            // console.log('changeTypeControl', type);
            this.searchForm.currentTab = type;
        },
        // 时间选择回调函数
        changeSelectTime(type, time) {
            if (type === 'year') {
                this.selectTime.year = time;
            }
            if (type === 'times') {
                Object.assign(this.selectTime, time.Lefttimes, time.Righttimes);
            }
            this.searchForm.queryDate = [
                `${this.selectTime.yearLeft}-${this.selectTime.monthLeft}-${this.selectTime.dayLeft} 00:00:00`,
                `${this.selectTime.yearRight}-${this.selectTime.monthRight}-${this.selectTime.dayRight} 23:59:59`,
            ];
        },

        /**
         * @description 河湖岛工程分布
         * @param {*} data
         */

        checkHeHuIslandProjectList(data) {
            this.heHuIslandProjectList = data || [];
        },
        // 数据点击定位
        dingweiClick(data) {
            let polygon = WktInstance.readGeometry(data.geometry);
            this.positionFitVal = [];
            // 2. 获取多边形的地理范围（[minX, minY, maxX, maxY]）
            const extent = polygon.getExtent();
            if (extent) {
                this.positionFitVal = extent;
            }
        },

        /**
         * 处理事件列表点击事件
         *
         * @param data 事件数据对象
         */
        handleEventListClick(data) {
            const { longitude, latitude } = data;

            if (longitude && latitude) {
                this.toMapCenter([longitude, latitude]);
            }
        },
        /**
         * 将地图中心点移动到指定位置
         *
         * @param center 地图中心点坐标，格式为 [经度, 纬度]
         */
        toMapCenter(center) {
            if (this.$refs.mapRef) {
                this.$refs.mapRef.toCenter(center);
                this.$refs.mapRef.toMapZoom(18);
            }
        },

        /**
         * 处理左侧事件列表
         *
         * @param data 触发事件时传递的数据
         * */
        onLeftEventData(data) {
            this.eventList = data || [];
        },
        /**
         * 右侧面板展开收起事件，展开时resize一下统计图表
         */
        handleToggleRight(visible) {
            if (visible) {
                setTimeout(() => {
                    this.$refs.rightRef && this.$refs.rightRef.resizeChart();
                }, 200);
            }
        },
        async getPanoramaLocationList() {
            let { data } = await apiPanorama.getPanoramaLocationList();
            this.panoramalocationList = data;
        },
    },
    mounted() {
        this.getPanoramaLocationList();
    },
    provide() {
        return {
            selectTime: this.selectTime, // 可传递响应式数据
            searchForm: this.searchForm, // 可传递响应式数据
        };
    },
};
</script>

<style lang="scss" scoped>
.c-middle {
    width: 100%;
    height: 100%;

    .compare-select-box {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1000;
        display: flex;

        ::v-deep .el-select-blue {
            .el-input__inner {
                background-color: #071150;
            }
        }
    }

    .legend-icon {
        display: inline-flex;
        width: 14px;
        height: 14px;
        font-size: 10px;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
    }
}
//用来切换后保存时间的东东
.hiddenSelectYear {
    visibility: hidden;
}
</style>
